/**
 * Generation d'IDs pour les nodes du layout et les instances de panels.
 *
 * Production : `crypto.randomUUID()` (browser + Node 19+).
 * Tests : factory deterministe injectable via `createSequentialIdFactory`.
 */

export type IdFactory = () => string;

export const defaultIdFactory: IdFactory = () =>
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `id-${Math.random().toString(36).slice(2, 12)}`;

/** Helper de test : retourne une factory deterministe ("id-1", "id-2", ...). */
export function createSequentialIdFactory(prefix = "id"): IdFactory {
  let counter = 0;
  return () => `${prefix}-${++counter}`;
}
